export const getPreviousEncounterEventDate = (patient) => {
  const events = patient.currentPingEncounter.events;
  const previousEvent = events.at(-2) ?? events[0];
  return new Date(previousEvent.eventDate);
};

export const getEncounterEventMinDate = (patient, isEditing) => {
  return isEditing ? getPreviousEncounterEventDate(patient) : new Date(patient.currentPing.eventDate);
};
